// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var merchantRouter = {
  path: '/merchant',
  component: Layout,
  redirect: '/merchant',
  name: 'Merchant',
  meta: {
    title: '商户',
    icon: 'clipboard'
  },
  children: [{
    path: 'classify',
    name: 'MerchantAlassify',
    component: function component() {
      return import('@/views/merchant/classify');
    },
    meta: {
      title: '商户分类',
      icon: ''
    }
  }, {
    path: 'list',
    name: 'MerchantList',
    component: function component() {
      return import('@/views/merchant/list');
    },
    meta: {
      title: '商户列表',
      icon: ''
    }
  }, {
    path: 'system',
    name: 'MerchantAystem',
    component: function component() {
      return import('@/views/merchant/system');
    },
    meta: {
      title: '商户菜单管理',
      icon: ''
    }
  }, {
    path: 'application',
    name: 'MerchantApplication',
    component: function component() {
      return import('@/views/merchant/application');
    },
    meta: {
      title: '商户入驻申请',
      icon: ''
    }
  }, {
    path: 'type',
    name: 'MerchantType',
    component: function component() {
      return import('@/views/merchant/type');
    },
    meta: {
      title: '店铺类型',
      icon: 'clipboard'
    },
    children: [{
      path: 'list',
      component: function component() {
        return import('@/views/merchant/type/list');
      },
      name: 'MerchantTypeList',
      meta: {
        title: '店铺类型',
        icon: ''
      }
    }]
  }, {
    path: 'open',
    component: function component() {
      return import('@/views/merchant/open/index');
    },
    name: 'openList',
    meta: {
      title: '开户管理',
      icon: ''
    },
    children: [{
      path: 'openapply',
      component: function component() {
        return import('@/views/merchant/open/openapply/index');
      },
      name: 'openApply',
      meta: {
        title: '用户开户',
        icon: ''
      }
    }, {
      path: 'openrecord',
      component: function component() {
        return import('@/views/merchant/open/openrecord/index');
      },
      name: 'openRecord',
      meta: {
        title: '开户记录',
        icon: ''
      }
    }, {
      path: 'openacct',
      component: function component() {
        return import('@/views/merchant/open/openacct/index');
      },
      name: 'openAcct',
      meta: {
        title: '用户信息',
        icon: ''
      }
    }, {
      path: 'bankapply',
      name: 'bankApply',
      meta: {
        title: '银行开户'
      },
      component: function component() {
        return import('@/views/merchant/open/openacct/bankapply');
      }
    }, {
      path: 'bankrecord',
      component: function component() {
        return import('@/views/merchant/open/bankrecord/index');
      },
      name: 'bankrecordIndex',
      meta: {
        title: '银行开户记录',
        icon: ''
      }
    }, {
      path: 'address/:userId',
      name: 'Address',
      meta: {
        title: '开户地址'
      },
      component: function component() {
        return import('@/views/merchant/open/openacct/address');
      }
    }]
  }, {
    path: 'fundinquiry',
    name: 'fundInquiry',
    component: function component() {
      return import('@/views/merchant/fundinquiry/index');
    },
    meta: {
      title: '资金查询'
    },
    children: [{
      path: 'funddetail',
      component: function component() {
        return import('@/views/merchant/fundinquiry/funddetail/index');
      },
      name: 'fundDetail',
      meta: {
        title: '资金明细',
        icon: ''
      }
    }]
  }, {
    path: 'fundProcessing',
    name: 'fundProcessing',
    component: function component() {
      return import('@/views/merchant/fundProcessing/index');
    },
    meta: {
      title: '资金处理'
    },
    children: [{
      path: 'transferRecords',
      component: function component() {
        return import('@/views/merchant/fundProcessing/transferRecords/index');
      },
      name: 'transferRecords',
      meta: {
        title: '转账记录',
        icon: ''
      }
    }, {
      path: 'withdrawalRecords',
      component: function component() {
        return import('@/views/merchant/fundProcessing/withdrawalRecords/index');
      },
      name: 'withdrawalRecords',
      meta: {
        title: '提现记录',
        icon: ''
      }
    }, {
      path: 'fund',
      component: function component() {
        return import('@/views/merchant/fundProcessing/fund/index');
      },
      name: 'fundIndex',
      meta: {
        title: '划拨记录',
        icon: ''
      }
    }]
  }]
};
export default merchantRouter;